<template>
  <div class="teleInfos">
    <div class="filters">
      <el-form :inline="true" :model="form" ref="form">
        <el-upload class="upload-demo" ref="uploading" action :on-remove="handleRemove" :on-change="handleSuccess"
          :on-exceed="outlimit" :on-error="uploadErr1" :limit="1" accept=".xlsx,.xls" :file-list="fileList"
          :auto-upload="false">
          <el-button slot="trigger" size="small" type="primary">{{$t('lang.btn_selectExcel')}}</el-button>
          <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">
            {{$t('lang.btn_importTaskExcel')}}</el-button>
        </el-upload> 
        <el-form-item :label="$t('lang.lab_PL_state')">
          <el-select v-model="form.state">
            <el-option v-for="item in TaskImportType" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="topics">{{$t('lang.btn_search')}}</el-button>
        <el-button type="primary" @click="createTask" :disabled="isCanUse">{{$t('lang.btn_createTask')}}</el-button>
         <el-button type="primary" @click="download">{{$t('lang.btn_excelDl')}}</el-button>       
      </el-form>
    </div>
    <el-card>
      <el-table :data="tableData" class="wid100"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="teleInfosListcheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <!-- 任务名称 -->
        <el-table-column prop="taskName" :label="$t('lang.lab_taskName')"></el-table-column>
        <!-- 设备名称 -->
        <el-table-column prop="deviceName" :label="$t('lang.lab_macName')"></el-table-column>
        <!-- 月 -->
        <el-table-column prop="impMouth" :label="$t('lang.lab_taskMonth')"></el-table-column>
        <!-- 天 -->
        <el-table-column prop="impDay" :label="$t('lang.lab_taskDay')"></el-table-column>
        <!-- 天 -->
        <el-table-column prop="impYear" :label="$t('lang.lab_taskYear')"></el-table-column>
        <!-- 开始时间 -->
        <el-table-column prop="startDate" :label="$t('lang.lab_startDate')">
          <template slot-scope="scope" v-if="scope&&scope.row.startDate">{{scope.row.startDate | formatDate}}</template>
        </el-table-column>
        <!-- 结束时间 -->
        <el-table-column prop="endDate" :label="$t('lang.lab_endDate')">
          <template slot-scope="scope" v-if="scope&&scope.row.endDate">{{scope.row.endDate | formatDate}}</template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operate" :label="$t('lang.lab_operation')" fixed="right"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button class="orange" @click="delTele(scope.row.id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加页码 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!-- 添加弹框 -->
    <el-dialog :title="titleShow" :visible.sync="diaIsShow" :close-on-click-modal="false" center top="130px"
      width="600px" @closed="handleDialogClosed">
      <!-- 表单验证 -->
      <el-form :model="form" :rules="rules" ref="form" :label-width="require('@/config/enum').c_ws4"
        :label-suffix="require('@/config/enum').c_colon">
        <!-- 名称 -->
        <el-form-item :label="$t('lang.lab_parkName')" prop="parkName">
          <el-input v-model="form.parkName" :placeholder="$t('lang.lab_parkName')" maxlength="11"></el-input>
        </el-form-item>
        <!-- 总人数 -->
        <el-form-item :label="$t('lang.lab_carTtotalNum')" prop="totalNum">
          <el-input v-model="form.totalNum" :placeholder="$t('lang.lab_carTtotalNum')" maxlength="6" @input="keyBA">
          </el-input>
        </el-form-item>
        <!--允许重复入场 -->
        <el-form-item :label="$t('lang.lab_isRepeat')" prop="isRepeat">
          <el-radio v-model="form.isRepeat" label='1'>{{$t('lang.lab_noAllow')}}</el-radio>
          <el-radio v-model="form.isRepeat" label='0'>{{$t('lang.lab_isAllow')}}</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="clear()">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" :disabled="isDisabled" @click="save('form')">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  /**
   *@ClassName:teleInfo
   *@Description:电话信息
   *@author:李斌
   *@Copyright:格众科技
   *@date:2020-03-13
   */
  import { mapGetters } from 'vuex'

  export default {
    filters: {
      formatDate(time) {
        var x = new Date(time)
        var z = {
          y: x.getFullYear(),
          M: x.getMonth() + 1,
          d: x.getDate(),
          h: x.getHours(),
          m: x.getMinutes(),
          s: x.getSeconds(),
        }
        if (z.M < 10) {
          z.M = '0' + z.M
        }
        if (z.d < 10) {
          z.d = '0' + z.d
        }
        if (z.h < 10) {
          z.h = '0' + z.h
        }
        if (z.m < 10) {
          z.m = '0' + z.m
        }
        return z.y + '-' + z.M + '-' + z.d
      }
    },
    data() {
      return {
        isDisabled: true, // 按钮置灰
        saveData: '', // 存储json字符串
        name: '', // 名称
        content: '', // 电话
        serviceTime: '', // 服务时间
        editId: '', // 接收参数
        titleShow: '', // 弹框标题
        diaIsShow: false, // 弹框是否显示
        pageNum: 1, // 页数
        pageSize: 10, // 每页数量
        pageCount: 0, // 总页数
        tableData: [], // 表单数据
        isCanUse: false,
        multipleSelection: [], // 多选框
        type: '', // 判断checkbox的值
        uploadFile: '',
        fileList: [], // 上传
        teleInfosListcheckbox: require('@/config/enum').teleInfosListcheckbox, // 是否隐藏复选框
        TaskImportType: this.$i18n.t('lang.TaskImportType'), // 类型下拉列表
        form: {
          state: 0,
        },
        rules: {
          parkName: [{
            required: true,
            message: this.$i18n.t('lang.lab_pleParkName'),
            trigger: 'blur'
          }],
          totalNum: [{
            required: true,
            message: this.$i18n.t('lang.lab_pleCarTtotalNum'),
            trigger: 'blur'
          }]
        },
      }
    },
    // 初始化
    created() {
      this.topics()
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    // 监听小区编号
    watch: {
      gardenId: function (newFlag, oldFlag) {
        this.topics()
      },
      form: {
        handler(newVal, oldVal) {
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            this.isDisabled = true
          } else {
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      // 上传文件的断网
      uploadErr1() {
        if (!navigator.onLine || window.navigator.onLine === false) {
          const loading = this.$loading()
          setTimeout(() => {
            loading.close()
            this.$message.error(this.$i18n.t('lang.lab_Online'))
          }, 500)
        }
      },
      // 文件上传数量超过提醒
      outlimit() {
        this.$message.warning(this.$i18n.t('lang.lab_uploadWarning'))
      },
      // 移除附件
      handleRemove(file, fileList) {
        console.log('Remove Success!', file, fileList)
        this.fileList = []
        this.uploadFile.length = 0
      },
      // 文件上传
      handleSuccess(e) {
        console.log('Upload Success!', e)
        this.uploadFile = e.raw
      },
      // 导入
      submitUpload() {
        if (this.uploadFile.length < 1) {
          this.$message.warning(this.$i18n.t('lang.lab_pleaseSeletcUploadDoc'))
        } else {
          let formData = new FormData()
          formData.append('excelFile', this.uploadFile)
          let loading = this.$loading()
          let gardenId = this.gardenId
          this.$postFormData(`/inputQuartzImport/` + gardenId, formData).then(
            res => {
              loading.close()
              this.$message.success(this.$i18n.t('lang.lab_uploadSuccess'))
              this.topics()
              this.fileList = []
            },
            error => {
              loading.close()
              this.$message({
                dangerouslyUseHTMLString: true,
                message: error,
                duration: 20000,
                showClose: true,
                type: 'warning'
              })
            }
          )
        }
      },
      // 下载模板
    download() {
      if (navigator.onLine) {
        window.open(require('@/config/enum').mouldTaskImport)
      } else {
        this.$message.error(this.$i18n.t('lang.lab_Online'))
      }
    },
      // 用户名只能输入数字
      keyBA() {
        // 仅保留数字和"."
        this.form.totalNum = this.form.totalNum.replace(/[^\d]/g, '')
        // 首位是0的话去掉
        if (this.form.totalNum.indexOf('.') < 0 && this.form.totalNum != '') {
          this.form.totalNum = parseFloat(this.form.totalNum)
        }
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      // 列表斑马线
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      topics() {
        let loading = this.$loading()
        this.$get(
          `/quartzImport?gardenId=${this.gardenId}&state=${this.form.state}&pageNo=${this.pageNum}&pageSize=${this.pageSize}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      createTask() {
        let loading = this.$loading()
        this.isCanUse = true
        this.$get(
          `/quartzJobImport/${this.gardenId}`
        ).then(
          res => {
            loading.close()            
            if (res && res.errCode === 0) {
              this.$message.success(this.$i18n.t('lang.lab_trialSuccess'))
              this.topics()
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 添加电话
      addTel() {
        this.editId = ''
        this.titleShow = this.$i18n.t('lang.lab_addPark')
        this.form.parkName = ''
        this.form.totalNum = ''
        this.form.isRepeat = '1'
        this.diaIsShow = true
      },
      // 修改电话信息
      changeTel(row) {
        this.editId = row.id
        this.titleShow = this.$i18n.t('lang.lab_changePark')
        this.form.parkName = row.parkName
        this.form.totalNum = Number(row.totalNum)
        this.form.isRepeat = row.isRepeat + ''
        this.saveData = JSON.stringify(this.form)
        this.diaIsShow = true
      },
      addPlace(id) {
        this.$router.push({
          path: '/manage/carPlaceList',
          query: {
            id: id
          }
        })
      },
      addGate(id) {
        this.$router.push({
          path: '/manage/carGateList',
          query: {
            id: id
          }
        })
      },
      // 删除
      delTele(id) {
        let loading = this.$loading()
        this.$confirm(
            this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            }
          ).then(() => {
            this.$delete(`quartzImport/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.topics()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      },
      // 保存
      save(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.editId === '') {
              let params = {
                gardenId: this.gardenId,
                parkName: this.form.parkName,
                totalNum: this.form.totalNum,
                isRepeat: this.form.isRepeat
              }
              if (this.gardenId === 0) {
                this.$message.error(this.$i18n.t('lang.reportPleaseSelectVillage'))
                return
              }
              let loading = this.$loading()
              this.$post(`/carPark/`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.diaIsShow = false
                    this.topics()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              let loading = this.$loading()
              let params = {
                parkName: this.form.parkName,
                totalNum: this.form.totalNum,
                isRepeat: this.form.isRepeat
              }
              this.$patch(`/carPark/${this.editId}`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.diaIsShow = false
                    this.topics()
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
              console.log(params.type)
            }
          }
        })
      },
      clear() {
        this.$refs.form.resetFields()
        this.form.parkName = ''
        this.form.totalNum = ''
        this.form.isRepeat = '1'
      },
      // 监听关闭dialog
      handleDialogClosed() {
        this.clear()
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNum = val
        this.topics()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        this.topics()
      }
    }
  }
</script>

<style lang="scss">
</style>